/**
 *
 * Dashboard
 *
 */

import { connect, ConnectedProps } from "react-redux";
import { compose } from "redux";
import { injectReducer, injectSaga, SagaInjectionModes } from "redux-injectors";

import Layout from "./layout";
import selectDashboardDataProps from "./selectors";

import reducer, { actionProps } from "./redux";
import saga from "./saga";
import withAuth from "utils/withAuth";
import { UserInfo } from "services/DTO/MFAmethodsDTO";
import { UserDetails } from "types/UserInfo";

const mapStateToProps = selectDashboardDataProps;
const mapDispatchToProps = actionProps;

const withConnect = connect<
  ReturnType<typeof mapStateToProps>,
  ReturnType<typeof mapDispatchToProps>,
  {} // own props type
>(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: "dashboardRoot", reducer });
const withSaga = injectSaga({
  key: "dashboardRoot",
  saga,
  mode: SagaInjectionModes.RESTART_ON_REMOUNT,
});

export default compose(
  withConnect,
  withReducer,
  withSaga,
  withAuth({ route: `${window.location.origin}/dashboard` })
)(
  Layout as React.ComponentType<
    ConnectedProps<
      typeof withConnect & { userInfo: UserInfo; userDetails: UserDetails }
    >
  >
);
